var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAuthentication } from "@aviv-unified-frontend/runtime/authentication";
import { useEffect, useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import { getCookieValue } from "@/utils";
export const useAuthenticationTracking = () => {
    var _a;
    const { authenticate, state, unsafe_accessToken } = useAuthentication();
    const decodedToken = unsafe_accessToken
        ? jwtDecode(unsafe_accessToken)
        : null;
    const userCid = (_a = getCookieValue("_ga")) === null || _a === void 0 ? void 0 : _a.split(".").slice(2).join(".");
    const userEmail = getCookieValue("oauth.partner.context");
    useEffect(() => {
        const checkAuthentication = () => __awaiter(void 0, void 0, void 0, function* () {
            yield authenticate({ shouldRedirect: false });
        });
        checkAuthentication();
    }, [authenticate]);
    const authTrackingData = useMemo(() => {
        var _a, _b;
        return ({
            uid: (_b = (_a = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.user_name) !== null && _a !== void 0 ? _a : decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.uid) !== null && _b !== void 0 ? _b : decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.sub,
            cid: userCid,
            email: userEmail,
            status: state === "authenticated" ? "logged" : "unlogged",
        });
    }, [decodedToken, state, userCid, userEmail]);
    const authTrackingLegacyData = useMemo(() => (Object.assign(Object.assign({}, ((decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.uid) && { user_id: decodedToken.uid })), { status: state === "authenticated" ? 1 : 0 })), [state, decodedToken]);
    if (state === "pending")
        return {
            authTrackingData: undefined,
            authTrackingLegacyData: undefined,
        };
    return {
        authTrackingData,
        authTrackingLegacyData,
    };
};
